import React from 'react'
import styled from 'styled-components'
import PackageIcon from '../../../../../../generic/icons/IconLib/PackageBoxIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import { ProductItem } from '../../../../../../modules/API/Market/models/marketRequests'

type Props = {
  product: ProductItem
}

const ProductCard: React.FC<Props> = ({ product }) => {
  return (
    <Card>
      <ProductRow>
        <ProductName>{product.desc}</ProductName>
      </ProductRow>
      <ProductRow>
        <ProductInfo>{product.qty}</ProductInfo>
        <PackageIcon />
        {
          product.grower.trim() !== "" && (
            <>
              <GrowerName>{product.grower}</GrowerName>
              <UserIcon />
            </>
          )
        }
      </ProductRow>
    </Card>
  )
}

const Card = styled.div`
  background: #f7fafc;
  border-radius: 15px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  transition: all 0.2s ease;
  border: 2px solid transparent;

  &:hover {
    background: #edf2f7;
    border-color: #297F76;
  }
`

const ProductRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  /* direction: rtl; */
  
  svg {
    color: #297F76;
    width: 1.1em; height: 1.1em;
  }
`

const ProductName = styled.span`
  font-weight: 600;
  font-size: 16px;
  color: #2d3748;
`

const ProductInfo = styled.span`
  font-weight: 500;
  font-size: 14px;
  color: #4a5568;
`

const GrowerName = styled.span`
  font-size: 13px;
  color: #718096;
`

export default ProductCard
